import { render } from "./DeleteAccountImage.vue?vue&type=template&id=5675b45a"
import script from "./DeleteAccountImage.vue?vue&type=script&lang=js"
export * from "./DeleteAccountImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__